type LabelMap = Record<string, string>;

export const LABEL: LabelMap = {
  REPORT_SCHEDULE: 'settings_autoReport_schedule',
  START_DATE: 'common_startDate',
  FILE_TYPE: 'common_fileType',
  RECIPIENT: 'common_recipientEmail',
  DESCRIPTION: 'settings_autoReport_emailBody',
  STATUS: 'common_status'
};
